// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS208: Avoid top-level this
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/main/docs/suggestions.md
 */
const FlowConfig = () => (function(config: any) {
   const values = config.flow
   const infoVals = config.info

   return {
      externalGroupId: `summonGroupId:${infoVals.libhash}`,
      clientName: infoVals.name.toUpperCase(),
      authUrl: values.auth_url,
      signupUrl: values.signup_url,
      logoutUrl: values.logout_url,
      clientId: values.client_id,
      libraryUrl: values.library_url,
      enabled: values.enabled
   }
})

angular.module('summonApp.factories.configs')
   .factory('flowConfig', FlowConfig)
